import { memo, useEffect, useState } from "react";
import useSound from "use-sound";
import { ENEMY_RADIUS } from "./constants";
import explosionSound from "./rajahdys.mp3";
import { Box, Container, useTick } from "./react-graphics";

type Props = {
  x: number;
  y: number;
  indestructible: boolean;
};

const Wreck = ({ x, y, indestructible }: Props) => {
  const [playExplosionSound] = useSound(explosionSound, { volume: 0.4 });
  useEffect(() => {
    playExplosionSound();
  }, [playExplosionSound]);
  const [explosionScale, setExplosionScale] = useState(1);
  const [rotation] = useState(() => Math.PI * Math.random());
  useTick((delta) => {
    setExplosionScale((scale) => Math.max(0, scale - 12 * delta));
  });
  const color = indestructible ? 0x008800 : 0xaaaaaa;
  return (
    <Container x={x} y={-y} rotation={rotation}>
      <Box
        x={0}
        y={0}
        width={1.4 * ENEMY_RADIUS}
        height={ENEMY_RADIUS}
        fillColor={color}
        pivotX={0.5}
        pivotY={0.5}
      />
      <Box
        x={-0.7 * ENEMY_RADIUS}
        y={0}
        width={0.1 * ENEMY_RADIUS}
        height={2 * ENEMY_RADIUS}
        fillColor={color}
        pivotX={0.5}
        pivotY={0.5}
      />
      <Box
        x={0.7 * ENEMY_RADIUS}
        y={0}
        width={0.1 * ENEMY_RADIUS}
        height={2 * ENEMY_RADIUS}
        fillColor={color}
        pivotX={0.5}
        pivotY={0.5}
      />
      <Box
        x={0}
        y={0}
        width={100 * explosionScale}
        height={100 * explosionScale}
        pivotX={0.5}
        pivotY={0.5}
        fillColor={0xffffff}
      />
    </Container>
  );
};

export default memo(Wreck);
